// 接口地址
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

// 项目名称
export const PROJECT_NAME = '老年用药风险智能预警与远程医疗协作平台'

// 不显示侧栏的路由
export const HIDE_SIDEBARS = []

// 不显示页脚的路由
export const HIDE_FOOTERS = [
]

// 页签同路由不同参数可重复打开的路由
export const REPEATABLE_TABS = []

// 不需要登录的路由
export const WHITE_LIST = ['/login', '/forget', '/500']

// 开启 KeepAlive 后仍然不需要缓存的路由地址
export const KEEP_ALIVE_EXCLUDES = []

// 直接指定菜单数据
export const USER_MENUS = [
  {
    name: 'patient',
    path: '/patient',
    component: '/patient/index',
    meta: { title: '患者管理', icon: 'el-icon-user-solid' },
    children: [
      {
        name: 'historyAssess',
        path: '/history-assess',
        component: '/patient/history-assess',
        meta: { title: '', hide: true }
      }
    ]
  },
  {
    name: 'drug',
    path: '/drug',
    component: '/drug/index',
    meta: { title: '多重用药管理', icon: 'el-icon--yaopinshuju' }
  },
  {
    name: 'compliance',
    path: '/compliance',
    component: '/compliance/index',
    meta: { title: '用药依从性管理', icon: 'el-icon--xcnlpg' }
  },
  {
    name: 'follow-up',
    path: '/follow-up',
    component: '/follow-up/index',
    meta: { title: '远程用药指导', icon: 'el-icon--yuanchenghuizhen' }
  },
  {
    name: 'adr',
    path: '/adr',
    component: '/adr/index',
    meta: { title: 'ADR上报管理', icon: 'el-icon--yichangshangbao_o' }
  },
  {
    name: 'dataview',
    path: '/dataview',
    component: '/dataview/index',
    meta: { title: '统计分析', icon: 'el-icon-s-data' }
  },
  {
    name: 'knowledge',
    path: '/knowledge',
    component: '/knowledge/index',
    meta: { title: '知识库', icon: 'el-icon--zhishiku' },
    children: [
      {
        name: 'knowledgeList',
        path: '/knowledge/list',
        component: '/knowledge/list',
        meta: { title: '', hide: true }
      },
      {
        name: 'knowledgeUpload',
        path: '/knowledge/upload',
        component: '/knowledge/upload',
        meta: { title: '', hide: true }
      }
    ]
  },
  {
    name: 'gpt',
    path: 'http://14.103.232.91/chatbot/lB8j9L6rJ78VaIo8',
    // component: '/gpt/index',
    meta: { title: 'AI问答', icon: 'el-icon--chatgpt' }
  },
  {
    name: 'view',
    path: '/view/:type/:elderlyId',
    component: '/view/index',
    meta: {
      title: '',
      hide: true,
      meun: [
        { key: 'patientRecord', title: '患者病历' },
        { key: 'earlyWarning', title: 'AI用药风险预警' },
        { key: 'drugAssessment', title: '多重用药评估' },
        { key: 'compliance', title: '用药依从性评估' },
        { key: 'chat', title: '远程用药指导' },
        { key: 'adr', title: 'ADR上报记录' },
        { key: 'cga', title: 'CGA评估' },
        { key: 'patientInfo', title: '患者档案' },
      ]
    }
  }
]

// 首页名称, 为空则取第一个菜单的名称
export const HOME_TITLE = undefined

// 首页路径, 为空则取第一个菜单的地址
export const HOME_PATH = undefined

// 外层布局的路由地址
export const LAYOUT_PATH = '/'

// 刷新路由的路由地址
export const REDIRECT_PATH = '/redirect'

// 开启页签栏是否缓存组件
//export const TAB_KEEP_ALIVE = process.env.NODE_ENV !== 'development';
export const TAB_KEEP_ALIVE = true

// token 传递的 header 名称
export const TOKEN_HEADER_NAME = 'Authorization'

// token 存储的名称
export const TOKEN_STORE_NAME = 'access_token'

// 主题配置存储的名称
export const THEME_STORE_NAME = 'theme'

// i18n 缓存的名称
export const I18N_CACHE_NAME = 'i18n-lang'

// 是否开启国际化功能
export const I18N_ENABLE = false

// 高德地图 key
export const MAP_KEY = ''

// EleAdmin 授权码, 自带的只能用于演示, 正式项目请更换为自己的授权码
export const LICENSE_CODE =
  'dk9mcwJyetRWQlxWRiojIqJWdzJCLi4Wa5gjMxojI0NWZiJlI6ICZpJCLiwiIQNTNZRzb6Iibvl2cyVmdQfiETMuEjI0NW=='
